export default "__VITE_ASSET__yU8UNgjl__"